import { getFormatName } from ".";
import { Format } from "../models/Contract";
import { AddsReport, NACCReport, SpinReport } from "../models/ContractPerformance";

function getHtmlForNACC(naccReports: NACCReport[]) {
    const Heavy = naccReports.filter((el)=> el.genre === Format.Metal);
    const Electronic = naccReports.filter((el)=> el.genre === Format.Electronic);
    const HipHop = naccReports.filter((el)=> el.genre === Format["Hip-Hop"]);
    const Top = naccReports.filter((el)=> el.genre === Format.College);

    let html = `<strong style="font-family: 'Helvetica Neue';"><u>NACC CHART SUPPORT</u></strong> <br><p style="margin-top:0; font-size: 9px; margin-bottom: 0 ;font-family: 'Helvetica Neue';">`;
    if(Top.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Top 200</u></strong><p style="margin-top:0; font-size: 9px; margin-bottom: 0 ;font-family: 'Helvetica Neue';">`
        Top.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""} (${el.naccRank})<br>`
        })
        html+="</p>"
    }
    if(Heavy.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Metal</u></strong> <p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        Heavy.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""} (${el.naccRank})<br>`
        })
        html+="</p>"
    }
    if(Electronic.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Electronic</u></strong><p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        Electronic.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""} (${el.naccRank})<br>`
        })
        html+="</p>"
    }
    if(HipHop.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>HipHop</u></strong><p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        HipHop.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""} (${el.naccRank})<br>`
        })
        html+="</p>"
    }


    html += "</p>"
    return html;
  }

  export function getHtmlForAdds(addsReports: AddsReport[]) {
    const Heavy = addsReports.filter((el)=> el.genre === Format.Metal);
    const Electronic = addsReports.filter((el)=> el.genre === Format.Electronic);
    const HipHop = addsReports.filter((el)=> el.genre === Format["Hip-Hop"]);
    const Top = addsReports.filter((el)=> el.genre === Format.College);

    let html = `<strong style="font-family: 'Helvetica Neue';"><u>NACC OFFICIAL ADDS</u></strong> <br><p style="margin-top:0; font-size: 9px; margin-bottom: 0 ;font-family: 'Helvetica Neue';">`;
    if(Top.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Top 200</u></strong><p style="margin-top:0; font-size: 9px; margin-bottom: 0 ;font-family: 'Helvetica Neue';">`
        Top.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""}<br>`
        })
        html+="</p>"
    }
    if(Heavy.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Metal</u></strong> <p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        Heavy.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""}<br>`
        })
        html+="</p>"
    }
    if(Electronic.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>Electronic</u></strong><p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        Electronic.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""}<br>`
        })
        html+="</p>"
    }
    if(HipHop.length>0){
        html += `<strong style="font-family: 'Helvetica Neue';"><u>HipHop</u></strong><p style="margin-top:0; font-size: 9px;margin-bottom: 0 ; font-family: 'Helvetica Neue';">`
        HipHop.forEach((el)=>{
            html+=`${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""}<br>`
        })
        html+="</p>"
    }


    html += "</p>"
    return html;
  }
  function getHtmlForSpins(spinReports: SpinReport[]) {
    let html = `<strong style="font-family: 'Helvetica Neue';"><u>AIRPLAY THIS WEEK</u></strong> <br><p style="margin-top:0; margin-bottom: 0 ; font-family: 'Helvetica Neue';">`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const groupedByGenre: { [key: string]: SpinReport[] } = spinReports.reduce((acc: any, obj) => {
        const key = getFormatName(obj['genre']) as string;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});

    Object.keys(groupedByGenre).forEach((key) => {
        html += `<strong style="font-family: 'Helvetica Neue';"><u>${key}</u></strong><p style="margin-top:0; font-size: 9px; font-family: 'Helvetica Neue';">`
        const genreReportSortedBySpinsNumber = groupedByGenre[key].sort((a, b) => {
            const spinCountComparison = parseInt(b.spinCount) - parseInt(a.spinCount);          
            if (spinCountComparison === 0) {
              return a.stationName.localeCompare(b.stationName);
            }          
            return spinCountComparison;
        });
        
        genreReportSortedBySpinsNumber.forEach((el: SpinReport) => {
            html += `${el.stationName}${el.stationLocation.length > 0 ? "- " + el.stationLocation : ""} (${el.spinCount}x)<br>`
        })
        html+="</p>"
    })
    
    html += "</p>"
    return html;
  }

  export {
    getHtmlForNACC,
    getHtmlForSpins
  }